<template>
  <div class="reportDetailPage">
    <div class="pom-bar">
      监测中心<span class="gray-line">/</span
      ><span style="cursor: pointer" @click="tolist()">安全报告列表</span
      ><span class="gray-line">/</span
      ><span class="active-bar">安全报告详情</span>
    </div>
    <div class="reportDetailPage_bar">
      <span class="reportDetailPage_bar__left"
        >{{ option.reportName }}
        <i>{{ option.reportTime }}</i>
      </span>
      <span class="reportDetailPage_bar__right" @click="exportReport"
        ><img src="./img/exprotIcon.png" /><i>报告导出</i></span
      >
    </div>

    <div id="report" >
      <div class="reportName">
        安全监测
<!--        <span style="float: right;cursor:pointer;" @click="openclose()">-->
        <span style="float: right;cursor:pointer;" >
<!--          <img src="../../assets/home/drapdown.png" alt="">-->
        </span>
      </div>
      <div class="top-con" :class="openclass">
        <box title="整体评估">
          <div class="reportDetailPage_context">
            <p>
              {{ getDate }}您的整体安全情况为“<em
              :style="`color:${getGrade(reportGrade.reportGrade)[0]}`"
            >{{ reportGrade.reportGradeDesc }}</em
            >“，{{ getGrade(reportGrade.reportGrade)[1] }}
            </p>
            <div class="chart_box">
              <i>{{ getDate }}日评分情况</i>
              <div class="chart" id="chart"></div>
            </div>
            <div class="chart_box">
              <i>{{ getDate }}日隐患分布情况</i>
              <div class="chart chart__bar">
                <div
                  class="bar"
                  v-for="(item, index) in weekDayData"
                  :key="index"
                >
                  <div class="bar__title">
                    <h3>{{ getItem(item) }}</h3>
                    <i> {{ item.date.substring(item.date.length - 2) }}</i>
                  </div>
                  <div class="bar__btm">
                    <div
                      class="bar__color"
                      :style="`background:${
                      getLevel(item)[1]
                    };height:${getHeight}`"
                    ></div>
                    <p>{{ getLevel(item)[0] }}</p>
                  </div>
                </div>
              </div>
            </div>
            <p>
              您的整改态度评分为
              <em :style="`color:${getGrade2(wholeHandleGrade)[0]}`">{{
                  wholeHandleGrade
                }}</em>
              分，{{ getGrade2(wholeHandleGrade)[1] }}
            </p>
            <div class="chart_box">
              <i>监测点整改评分占比情况</i>
              <div class="chart" id="chart02">
                <div class="noData">
                  <img src="./img/noChart.png" />
                  <p>暂无数据</p>
                </div>
              </div>
            </div>
            <div class="chart_box">
              <i>未整改隐患占比情况</i>
              <div class="chart" id="chart03" ref="chart03">
                <div class="noData">
                  <img src="./img/noChart.png" />
                  <p>暂无数据</p>
                </div>
              </div>
            </div>
          </div>
        </box>
        <box title="隐患诊断">
          <div class="dns_box">
            <div class="chart_box">
              <p>
                {{ getDate }}的监测点隐患{{ riskTotal }}项，其中重大风险{{
                  significantRiskCount
                }}项，较大风险{{ greaterRiskCount }}项，误报{{
                  falseAlarmCount
                }}项
              </p>
              <div class="chart" id="chart04">
                <div class="noData">
                  <img src="./img/noChart.png" />
                  <p>暂无数据</p>
                </div>
              </div>
            </div>
            <div class="chart_box">
              <p>
                {{ getDate }}隐患最多的监测点是“{{
                  (riskCount[0] || {}).monitorName || "-"
                }}”，共发现隐患{{ (riskCount[0] || {}).riskCount || 0 }}项
              </p>
              <el-table class="tableList" :data="riskCount">
                <el-table-column
                  type="index"
                  width="80"
                  align="center"
                  label="排名"
                ></el-table-column>
                <el-table-column
                  prop="monitorName"
                  label="监测点名称"
                ></el-table-column>
                <el-table-column
                  prop="riskCount"
                  label="隐患数量（项）"
                  align="center"
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </box>
        <box title="告警诊断">
          <div class="dns_box">
            <div class="chart_box">
              <p>{{ getDate }}的告警事件总共{{ reportSummary.eventCount }}项</p>
              <div class="chart" id="chart05">
                <div class="noData">
                  <img src="./img/noChart.png" />
                  <p>暂无数据</p>
                </div>
              </div>
            </div>
            <div class="chart_box">
              <p>
                {{ getDate }}监测点事件告警最多的是“{{
                  (eventCount[0] || {}).monitorName || "-"
                }}”，共告警{{ (eventCount[0] || {}).eventCount || 0 }}次
              </p>
              <el-table class="tableList" :data="eventCount">
                <el-table-column
                  type="index"
                  width="80"
                  align="center"
                  label="排名"
                ></el-table-column>
                <el-table-column
                  prop="monitorName"
                  label="监测点名称"
                ></el-table-column>
                <el-table-column
                  prop="eventCount"
                  label="告警数量（项）"
                  align="center"
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </box>
        <box title="诊断结论" class="bottom__box">
          <div class="bottom__body">
            <p>
              诊断情况：共诊断{{ reportSummary.monitorCount }}个监测点（共计发现{{
                reportSummary.riskCount
              }}项隐患和{{
                reportSummary.eventCount
              }}次告警），其中有重大风险的监测点{{
                reportSummary.significantRiskMonitorCount
              }}个，有较大风险隐患的监测点{{
                reportSummary.greaterRiskMonitorCount
              }}个
            </p>
            <p>
              需要整改：需整改的隐患共计{{
                reportSummary.riskCount - reportSummary.handledRiskCount
              }}个，其中重大风险隐患{{
                reportSummary.significantRiskUnhandledCount
              }}项，较大风险隐患{{ reportSummary.greaterRiskUnhandledCount }}项
            </p>

            <div class="btTableList">
              <el-table class="tableList" :data="unhandledRiskList">
                <el-table-column
                  label="隐患等级"
                  prop="riskLevelName"
                ></el-table-column>
                <el-table-column
                  label="隐患类型"
                  prop="riskName"
                ></el-table-column>
                <el-table-column
                  label="隐患监测点"
                  prop="monitorName"
                ></el-table-column>
                <el-table-column
                  label="上报时间"
                  prop="createTime"
                ></el-table-column>
                <el-table-column label="逾期时间" prop="expireDay">
                  <template slot-scope="scope">
                    <span>{{ scope.row.expireDay || 0 }}天</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </box>
      </div>
      <div class="reportName">
        能源监测
<!--        <span style="float: right;cursor:pointer;" @click="bomclose()">-->
        <span style="float: right;cursor:pointer;" >
<!--          <img src="../../assets/home/drapdown.png" alt="">-->
        </span>
      </div>
      <div class="bom-con" :class="bomclass">
        <box title="整体统计">
          <div class="reportDetailPage_context">
            <div class="dns_box">
              <p>{{ getDate }}您的总能耗为 {{ holesumdata.energyTotal }} kwh，环比{{ Number(holesumdata.ringRatio)>0?'上升':'下降'   }}{{holesumdata.ringRatio}}%（上期能耗：{{holesumdata.lastPeriodEnergyTotal}}kwh），请查看用电统计。</p>
              <div class="holechart" id="chart08">
                <div class="noData">
                  <img src="./img/noChart.png" />
                  <p>暂无数据</p>
                </div>
              </div>
            </div>
          </div>
        </box>
        <box title="占比统计">
          <div class="reportDetailPage_context">
            <div class="dns_box">
              <p>查看本期您的监测点中耗能排名前列用电情况：</p>
              <div class="partchart" id="chart09">
                <div class="noData">
                  <img src="./img/noChart.png" />
                  <p>暂无数据</p>
                </div>
              </div>
              <div class="partdetail">
                <ul>
                  <li v-for="(item , index) in parsumlist"><span class="cir-fang" :style="{background: colorList[index]}" ></span><span class="name">{{ item.monitorSiteName }}</span><span class="stavale">{{ item.monitorSiteDegree }}(kwh)</span></li>
                </ul>
              </div>
            </div>
          </div>
        </box>
        <box title="异常用电">
          <div class="reportDetailPage_context">
            <div class="dns_box">
              <div style="margin: 20px;">
                请选择展示条数：
                <el-select
                  v-model="tabnum"
                  @change="onchange"
                >
                  <el-option
                    v-for="item in tablist"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>

              <div class="bigtableList" :style="'height:'+nowheight">
                <el-table  :data="eventList">
                  <el-table-column

                    prop="deptName"

                    label="单位名称"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="monitorSiteName"
                    label="监测点名称"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="energy"
                    label="能耗"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="lastPeriodEnergy"
                    label="上期能耗"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    prop="floatRatio"
                    label="变化幅度"
                    align="center"
                  ></el-table-column>
                </el-table>
              </div>

            </div>
          </div>
        </box>
      </div>
    </div>

    </div>
</template>

<script>
import Bus from "utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import box from "../component/box";
import echarts from "echarts";
import htmlToPdf from "@/utils/downloadPDF";
export default {
  name: "reportDetailPage",
  components: { box },
  data() {
    return {
      chart: null,
      tabnum: 10,
      nowheight: "462px",
      tablist:[
        {
        label:10,
        value:10
      },

        {
          label:20,
          value:20
        },
        {
          label:50,
          value:50
        },
        {
          label:100,
          value:100
        },
      ],
      chart02: null,
      chart03: null,
      chart04: null,
      chart05: null,
      openclass:"",
      bomclass:"",
      isopen:true,
      bomopen:true,
      option: {},
      riskCount: [
        {
          monitorName: "",
          riskCount: 0,
        },
      ],
      eventCount: [
        {
          monitorName: "",
          eventCount: 0,
        },
      ],
      holesumdata:{
        "energyTotal": 0,
        "energyTrends": [
          {
            "dataTime": "",
            "energy": 0,
            "lastPeriodEnergy": 0
          }
        ],
        "lastPeriodEnergyTotal": 0,
        "ringRatio": ""
      },
      wholeHandleGrade: 0, //评分
      reportGrade: {}, //本周
      reportSummary: {}, //诊断结论
      unhandledRiskList: [], //诊断未整改列表
      weekDayData: [], //本周数据
      eventList: [], //异常预警
      riskTotal: 0, //本周隐患总量
      significantRiskCount: 0, //重大
      greaterRiskCount: 0, //较大
      falseAlarmCount: 0, //误报
      colorList:[
        "#008B61",
        "#36CD28",
        "#49B4FF",
        "#5482FC",
        "#B756FC",
        "#FCD654",
        "#FF5151",
        "#022B61",
        "#ffC338",
        "#49ff5F",
        "#5482FC",
        "#1156FC",
        "#FC3354",
        "#005151",
        "#022Bff",
        "#36C3cc",
        "#49B96d",
        "#548211",
        "#115655",
        "#FC33aa",
        "#0051cc",
      ],
      parsumlist:[]

    };

  },
  computed: {
    getDate() {
      return this.option.reportType == "周报告" ? "本周" : "本月";
    },
    getHeight() {
      return this.option.reportType == "周报告" ? "135px" : "115px";
    },
  },
  methods: {
    onchange(val){

      //**10*42
      if(val<this.eventList.length){
        this.nowheight=((val+1) * 42 )+'px'
      }else{
        this.nowheight=((this.eventList.length+2) * 42 )+'px'
      }

    },
    bomclose(){
      if(this.bomopen==true){
        this.bomclass='closetc2'
        this.bomopen=false
      }else if(this.bomopen==false){
        this.bomclass='opentc2'
        this.bomopen=true
      }
    },
    openclose(){
      if(this.isopen==true){
        this.openclass='closetc'
        this.isopen=false
      }else if(this.isopen==false){
        this.openclass='opentc'
        this.isopen=true
      }
    },
    tolist() {
      this.$router.push("/reportList");
    },
    exportReport() {
      let that = this
        if(this.isopen && this.bomopen){
          htmlToPdf.downloadPDF(
            document.querySelector("#report"),
            that.option.reportName
          );
        }else{
          this.openclass='opentc'
          this.isopen=true
          this.bomclass='opentc2'
          this.bomopen=true
          setTimeout(function(){
            htmlToPdf.downloadPDF(
              document.querySelector("#report"),
              that.option.reportName
            );
          },2000)
        }



    },
    getItem(item) {
      switch (item.dayOfWeek) {
        case 1:
          return "日";
        case 2:
          return "一";
        case 3:
          return "二";
        case 4:
          return "三";
        case 5:
          return "四";
        case 6:
          return "五";
        case 7:
          return "六";
        default:
          return "一";
      }
    },
    getLevel(item) {
      switch (item.mostSeriousRiskLevel) {
        case 1:
          return ["正常", "#00B57F"];
        case 2:
          return ["早期风险", "#1E50D6"];
        case 3:
          return ["一般风险", "#FADB14"];
        case 4:
          return ["较大风险", "#FFA940"];
        case 5:
          return ["重大风险", "#D61E1E"];
        case 6:
          return ["误报", "#C8CFE0"];
        default:
          return ["正常", "#00B57F"];
      }
    },
    getGrade(item) {
      switch (item) {
        case 5:
          return ["#00B57F", "请继续保持哦！"];
        case 4:
          return ["#36CD28", "请继续加油哦！"];
        case 3:
          return ["#5482FC", "请继续加油哦！"];
        case 2:
          return ["#FF7528", "请及时排查！"];
        case 1:
          return ["#FF5151", "请及时排查！"];
        default:
          return ["#36CD28", "请继续加油哦！"];
      }
    },
    getGrade2(item) {
      if (item >= 90) {
        return ["#00B57F", "整体态度积极，请继续保持哦！"];
      }
      if (item >= 80) {
        return ["#36CD28", "整体态度良好，请继续加油哦！"];
      }
      if (item >= 70) {
        return ["#5482FC", "整体态度一般，请继续加油哦！"];
      }
      if (item >= 60) {
        return ["#FF7528", "整体态度较差，请注意哦！"];
      }
      if (item < 60) {
        return ["#FF5151", "整体态度恶劣，请及时纠正！"];
      }
    },
    // initChart() {
    //   this.$nextTick(() => {
    //     this.chart = echarts.init(this.$refs.chart);
    //     this.chart02 = echarts.init(this.$refs.chart02);
    //     // this.chart03 = echarts.init(this.$refs.chart03);
    //     this.chart04 = echarts.init(this.$refs.chart04);
    //     this.chart05 = echarts.init(this.$refs.chart05);
    //   });
    // },
    renderChart(data) {
      const chart = this.$echarts.init(document.getElementById("chart"));
      const option = {
        tooltip: {
          trigger: "axis",
        },

        grid: {
          right: "5%",
          bottom: "10px",
          left: "6%",
          top: "30px",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data.map((item) => item.date),
            axisLine: {
              lineStyle: {
                color: "#0B4CA9",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#000",
                fontSize: 12,
              },
              //interval:0,
              //rotate:30
            },
          },
        ],
        yAxis: [
          {
            min: 1,
            max: 5,
            nameTextStyle: {
              color: "#000",
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#0B4CA9",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#000",
                fontSize: 12,
              },
              formatter: function (value, index) {
                let grade = "";
                switch (value) {
                  case 5:
                    grade = "优秀";
                    break;
                  case 4:
                    grade = "良好";
                    break;
                  case 3:
                    grade = "一般";
                    break;
                  case 2:
                    grade = "较差";
                    break;
                  case 1:
                    grade = "差";
                    break;
                }
                return grade;
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#0B4CA9",
              },
            },
          },
        ],
        series: [
          {
            name: "评分",
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                color: "rgba(32, 95, 235, 0.6)",
              },
            },
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(32, 95, 235, 0.5)", // 0% 处的颜色
                  },

                  {
                    offset: 1,
                    color: "rgba(32, 95, 235, 0.1)", //0% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
            data: data.map((item) => item.reportGrade),
          },
        ],
      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    renderChart02(data) {
      const chart = this.$echarts.init(document.getElementById("chart02"));
      const option = {
        color: ["#36CD28", "#5482FC", "#FCD654", "#FF5151"],
        title: {
          text: "监测点总量",
          subtext: data.monitorCount + "个",
          show: true,
          textStyle: {
            // color: "",
            fontWeight: "normal",
            fontSize: 18,
            lineHeight: 20,
          },
          subtextStyle: {
            color: "#25282a",
            fontWeight: "bold",
            fontSize: 28,
          },
          x: "30%",
          y: "40%",
          textAlign: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "25%",
        },
        series: [
          {
            name: "监测点整改评分占比情况",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: data.ge90, name: "90以上" },
              { value: data.ge80, name: "80以上" },
              { value: data.ge60, name: "60以上" },
              { value: data.lt60, name: "60以下" },
            ],
          },
        ],
      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    renderChart03(data) {
      const chart = this.$echarts.init(document.getElementById("chart03"));
      const option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "15%",
        },
        series: [
          {
            name: "未整改隐患占比",
            type: "pie",
            radius: [0, 100],
            center: ["30%", "50%"],
            label: {
              show: false,
            },
            data: data.map((item) => {
              return {
                name: item.riskName,
                value: item.unhandledProportion,
              };
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    renderChart04(data) {
      const chart = this.$echarts.init(document.getElementById("chart04"));
      const option = {
        color: [
          "#008B61",
          "#36CD28",
          "#49B4FF",
          "#5482FC",
          "#B756FC",
          "#FCD654",
          "#FF5151",
        ],
        title: {
          text: "隐患总量",
          subtext: this.riskTotal + "个",
          show: true,
          textStyle: {
            // color: "",
            fontWeight: "normal",
            fontSize: 18,
            lineHeight: 20,
          },
          subtextStyle: {
            color: "#25282a",
            fontWeight: "bold",
            fontSize: 28,
          },
          x: "30%",
          y: "40%",
          textAlign: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "20%",
        },
        series: [
          {
            name: "监测点隐患",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["30%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data.map((item) => {
              return {
                value: item.proportion,
                name: item.riskName,
              };
            }),
          },
        ],
      };
      chart.setOption(option, true);
      window.onresize = chart.resize;
    },
    renderChart05(data) {
      const chart = this.$echarts.init(document.getElementById("chart05"));
      const option = {
        color: [
          "#008B61",
          "#36CD28",
          "#49B4FF",
          "#5482FC",
          "#B756FC",
          "#FCD654",
          "#FF5151",
          "#FF7528",
          "#FFAB46",
          "#FF3671",
          "#34ef0b",
        ],
        title: {
          text: "告警总量",
          subtext: this.reportSummary.eventCount + "个",
          show: true,
          textStyle: {
            // color: "",
            fontWeight: "normal",
            fontSize: 18,
            lineHeight: 20,
          },
          subtextStyle: {
            color: "#25282a",
            fontWeight: "bold",
            fontSize: 28,
          },
          x: "20%",
          y: "40%",
          textAlign: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "0%",
        },
        series: [
          {
            name: "监测点隐患",
            type: "pie",
            radius: ["40%", "70%"],
            center: ["20%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data.map((item) => {
              return {
                value: item.proportion,
                name: item.eventName,
              };
            }),
          },
        ],
      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    queryperData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/monitorEnergyProportion";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {

        this.parsumlist=res.data.monitorSiteProportions
        this.renderChart09(res.data.monitorSiteProportions,res.data.wholeDegree)
      });
    },
    querynorlist() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/monitorsEnergyFloat";
      param.data = {
        reportId: this.option.reportId,
        showCount: 10,
      };
      Axios.ajax(param).then((res) => {

    this.eventList=res.data

      });
    },
    queryholeProportionData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/energyTrendTotal";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {

        this.holesumdata=res.data
        this.renderChart08(res.data.energyTrends)
      });
    },
    renderChart08(data) {
      const chart = this.$echarts.init(document.getElementById("chart08"));
      let xdata=[]
      let ydata1=[]
      let ydata2=[]
      for(let i=0;i<data.length;i++){
         xdata.push(data[i].dataTime)
         ydata1.push(data[i].energy)
         ydata2.push(data[i].lastPeriodEnergy)
      }
      let option = {
        tooltip: {
          trigger: 'axis',
          confine:true,

          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        // "dataZoom": [{
        //   "show": true,
        //   "height": 20,
        //   "xAxisIndex": [
        //     0
        //   ],
        //   bottom:'0',
        //   "start": 10,
        //   "end": 90,
        //   handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
        //   handleSize: '110%',
        //   handleStyle:{
        //     color:"#d3dee5",
        //
        //   },
        //   textStyle:{
        //     color:"#000"},
        //   borderColor:"#90979c"
        // }, {
        //   "type": "inside",
        //   "show": true,
        //   "height": 20,
        //   "start": 1,
        //   "end": 35
        // }],
        grid: {
          right: '5%',
          bottom: '8%',
          left: '6%',
          top: '20px',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            },
            //interval:0,
            //rotate:30
          },
        }],
        yAxis: [
          {
            type: 'value',

            nameTextStyle: {
              color: '#000'
            },
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },
            splitLine: {
              show:false,
              lineStyle: {
                color: "#0B4CA9",
              }

            },
            axisLabel: {
              color: '#000',
              fontSize: 12,
            }
          },
          {
            type: 'value',

            nameTextStyle: {
              color: '#000'
            },
            position: 'right',
            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },
            splitLine: {
              show:false,
              lineStyle: {
                color: "#0B4CA9",
              }

            },
            axisLabel: {
              color: '#000',
              fontSize: 12,
            }
          }
        ],
        series: [
          {
            name: '本期能耗',
            type: 'line',

            smooth:true,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "rgba(87,128,250,1)"
                }, {
                  offset: 1,
                  color: "rgba(87,128,250,1)"
                }]),
                barBorderRadius: 11,

              }
            },
            data: ydata1
          },
          {
            name: '上期能耗',
            type: 'line',

            smooth:true,
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: "#85f67a"
                }, {
                  offset: 1,
                  color: "#85f67a"
                }]),
                barBorderRadius: 11,

              }
            },
            data: ydata2
          }
        ]

      };
      chart.setOption(option);
      window.onresize = chart.resize;
    },
    renderChart09(data,sum) {
      const chart = this.$echarts.init(document.getElementById("chart09"));
      const option = {
        color:this.colorList,
        title: {
          text: "监测点用能占比",
          subtext: sum + "kwh",
          show: true,
          textStyle: {
            // color: "",
            fontWeight: "normal",
            fontSize: 18,
            lineHeight: 20,
          },
          subtextStyle: {
            color: "#25282a",
            fontWeight: "bold",
            fontSize: 28,
          },
          x: "50%",
          y: "40%",
          textAlign: "center",
        },
        tooltip: {
          trigger: "item",
        },
        // legend: {
        //   orient: "vertical",
        //   top: "center",
        //   right: "20%",
        // },
        series: [
          {
            name: "监测点隐患",
            type: "pie",
            radius: ["40%", "80%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: "40",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: data.map((item) => {
              return {
                value: item.monitorSiteDegree,
                name: item.monitorSiteName,
              };
            }),
          },
        ],
      };
      chart.setOption(option, true);
      window.onresize = chart.resize;
    },
    queryDateRiskGrade() {
      const params = {
        url: "/safeReport/getSafeReportDateRiskGrade",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      };
      Axios.ajax(params).then((res) => {
        if (res.data) {
          this.renderChart(res.data);
        }
      });
    },
    queryRiskGrade() {
      const params = {
        url: "/safeReport/getSafeReportRiskGrade",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      };
      Axios.ajax(params).then(({ data }) => {
        if (data) {
          this.reportGrade = data;
        }
      });
    },
    queryReportSummary() {
      Axios.ajax({
        url: "/safeReport/getReportSummary",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      }).then(({ data }) => {
        if (data) {
          this.reportSummary = data;
        }
      });
    },
    queryUnhandledRiskList() {
      Axios.ajax({
        url: "/safeReport/getUnhandledRiskList",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      }).then(({ data }) => {
        if (data) {
          this.unhandledRiskList = data;
        }
      });
    },
    queryDayWeekData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/getDateMostSeriousRiskLevel";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.weekDayData = res.data;
        }
      });
    },
    queryStagRadeData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/getMonitorHandleGrade";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {
        if (res.data) {
          this.wholeHandleGrade = res.data.wholeHandleGrade || 100;
          if (res.data.monitorCount != 0) {
            this.renderChart02(res.data);
          }
        }
      });
    },
    queryUnhandledRiskData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/getUnhandledRisk";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {
        if (res.data.length != 0) {
          this.renderChart03(res.data);
        }
      });
    },
    queryAlertLevelProportionData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/getAlertLevelProportion";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {
        if (res.data.length != 0) {
          this.renderChart04(res.data);
        }
      });
    },
    queryMonitorRiskCount() {
      Axios.ajax({
        url: "/safeReport/getMonitorRiskCount",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      }).then(({ data }) => {
        if (data) {
          this.riskCount = data;
        }
      });
    },
    queryMonitorEventCount() {
      Axios.ajax({
        url: "/safeReport/getMonitorEventCount",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      }).then(({ data }) => {
        if (data) {
          this.eventCount = data;
        }
      });
    },
    queryEventProportionData() {
      let param = {};
      param.method = "post";
      param.url = "/safeReport/getEventProportion";
      param.data = {
        reportId: this.option.reportId,
      };
      Axios.ajax(param).then((res) => {
        if (res.data.length != 0) {
          this.renderChart05(res.data);
        }
      });
    },
    queryRiskCount() {
      Axios.ajax({
        url: "/safeReport/getRiskCount",
        method: "post",
        data: {
          reportId: this.option.reportId,
        },
      }).then(({ data }) => {
        if (data) {
          this.riskTotal = data.riskTotal;
          this.significantRiskCount = data.significantRiskCount;
          this.greaterRiskCount = data.greaterRiskCount;
          this.falseAlarmCount = data.falseAlarmCount;
        }
      });
    },
  },
  created() {
    this.option = JSON.parse(this.$route.query.row); //防止刷新数据丢失
    this.queryReportSummary(); //诊断结论详情
    this.queryRiskCount(); //告警隐患数量
  },
  mounted() {
    // this.initChart();
    this.queryRiskGrade(); //风险等级
    this.queryDateRiskGrade(); //第一个图表
    this.queryholeProportionData(); //整体统计
    this.querynorlist(); //异常预警
    this.queryperData(); //占比统计
    this.queryDayWeekData(); //本周日隐患分布情况
    this.queryStagRadeData(); //第二个图表
    this.queryUnhandledRiskData(); //第三个图表
    this.queryAlertLevelProportionData(); //第四个图表
    this.queryMonitorRiskCount(); //第四个图表右侧的列表数据
    this.queryEventProportionData(); //第五个图表
    this.queryMonitorEventCount(); //第五个图表右侧列表数据
    this.queryUnhandledRiskList(); //诊断结论数据
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.opentc{

  animation: open 1s;
  animation-fill-mode : forwards;
}
.closetc{
  animation: close 1s;
  animation-fill-mode : forwards;
}
.opentc2{

  animation: open2 1s;
  animation-fill-mode : forwards;
}
.closetc2{
  animation: close2 1s;
  animation-fill-mode : forwards;
}
@keyframes open
{
  from {  height: 0px;}
  to {height: 2350px;}
}
@keyframes close
{
  from {  height: 2350px;}
  to {height: 0px;}
}
@keyframes open2
{
  from {  height: 0px;}
  to {height: 1800px;}
}
@keyframes close2
{
  from {  height: 1800px;}
  to {height: 0px;}
}
#report{

}
.holechart{
  margin-top: 18px;
  width: 1500px;
  height: 284px;
  background: #f4f6fa;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.partchart{
  display: inline-block;
  vertical-align: top;
  width: 600px;
  height: 284px;
}
.partdetail{
  display: inline-block;
  vertical-align: top;
  width: 800px;
  margin-left: 60px;
  li{
    float: left;
    display: flex;

    width: 360px;
    margin-left: 20px;
    height: 30px;

    margin-bottom: 16px;
    font-size: 16px;
    .cir-fang{
      display: inline-block;
      width: 10px;
      height: 10px;
      margin-top: 6px;
      margin-right: 10px;
    }
    .name{
      width: 180px;
      margin-right: 20px;
      display: inline-block;
    }
    .stavale{
      display: inline-block;

      margin-right: 20px;
    }
  }
}
.top-con{
  height: 2350px;
  overflow: hidden;
}
.bom-con{


}
.main-con{
  width: 100%;
  height: 300px;
}
.reportName{
  width: 100%;
  height: 70px;
  padding: 0 36px;
  font-size: 20px;
  color: #252b3c;
  line-height: 70px;
  background-color: #fff;
  img{
    position: relative;
    top: 20px;
  }
}
.tableList {
  height: 290px;
  overflow: auto;
}
.reportDetailPage {
  margin-bottom: 36px;
  &_bar {
    width: 100%;
    height: 80px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 36px;
    margin-bottom: 12px;
    &__left {
      font-size: 18px;
      color: #252b3c;
      font-weight: normal;
      i {
        margin-left: 30px;
        color: #7d879f;
        font-size: 14px;
      }
    }
    &__right {
      color: #2a62ff;
      font-size: 14px;
      cursor: pointer;
      img {
        margin-right: 11px;
        margin-top: 2px;
      }
    }
  }
  .reportDetailPage_context {
    padding: 0px 36px 36px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 12px;
    p {
      width: 100%;
      font-size: 14px;
      color: #252b3c;
      margin: 18px 0;
    }
    .chart_box {
      i {
        color: #7d879f;
      }
      .chart {
        margin-top: 18px;
        width: 768px;
        height: 284px;
        background: #f4f6fa;
        display: flex;
        justify-content: space-around;
        align-items: center;
        p {
          color: #7d879f;
          text-align: center;
        }
      }
      .chart__bar {
        padding: 9px 36px;
        .bar {
          height: 100%;
          width: 100%;
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          &__title {
            padding: 5px 0;
            background: rgba(#8c8c8c, 0.1);
            h3 {
              color: #000;
            }
            i {
              color: rgba(#000, 0.5);
              font-size: 12px;
            }
          }
          &__btm {
            .bar__color {
              width: 15px;
              min-height: 115px;
              border-radius: 4px;
              margin: 10px auto 0;
            }
          }
        }
      }
    }
  }
  .dns_box {
    margin-bottom: 12px;
    padding: 0px 36px 36px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 12px;
    .chart_box {
      width: 768px;
      .chart {
        height: 284px;
        .noData {
          height: 100%;
          color: #7d879f;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          p {
            border: none;
          }
        }
      }
      p {
        margin: 24px 0;
        padding-left: 14px;
        border-left: #2a62ff 2px solid;
      }
      .tableList {
        height: 290px;
        overflow: auto;
      }
    }
  }
  .bottom__box {
    .bottom__body {
      padding: 0 36px 18px;
      p {
        margin: 16px 0;
      }
      .btTableList {
        height: 360px;
        overflow-y: auto;
        .tableList {
          margin-top: 16px;
        }
      }
    }
  }
}
.bigtableList {
  width:1500px;
 padding-bottom: 20px;
 height: 600px;
overflow: auto;
}
.pom-bar {
  background: #ffffff;
  border-radius: 0px 4px 4px 4px;
  height: 58px;
  padding: 24px 0 0 36px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #7d879f;
  .active-bar {
    color: #252b3c;
  }
  .gray-line {
    margin: 0 6px;
  }
}

</style>
